import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getCheckboxActions(_obj, params) {
    const res = await axios.get(`api/lms/checkbox-actions/`, { params });
    return res.data;
  },
  async getAssignments(_obj, params) {
    const res = await axios.get(`api/lms/assignments/`, { params });
    return res.data;
  },
  async getAssignment(_obj, id) {
    const res = await axios.get(`api/lms/assignments/${id}/`);
    return res.data;
  },
  async createAssignment(_obj, data) {
    const res = await axios.post(`api/lms/assignments/`, data);
    return res.data;
  },
  async updateAssignment(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/assignments/${id}/`, data);
    return res.data;
  },
  async deleteAssignment(_obj, id) {
    const res = await axios.delete(`api/lms/assignments/${id}/`);
    return res.data;
  },
  // --- Scenario interviews (student side) -------------------------------
  // The LMS hands the student off here with assignment/lesson/task ids; these
  // three calls cover brief -> start -> confirm completion.
  async getScenarioContext(_obj, params) {
    const res = await axios.get(`api/lms/assignment-submissions/scenario/context/`, { params });
    return res.data;
  },
  async startScenarioInterview(_obj, data) {
    const res = await axios.post(`api/lms/assignment-submissions/scenario/start/`, data);
    return res.data;
  },
  async getScenarioTaskStatus(_obj, params) {
    const res = await axios.get(`api/lms/assignment-submissions/task-status/`, { params });
    return res.data;
  },
  async getAssignmentsList(_obj, params) {
    const res = await axios.get(`api/lms/assignments/assignment-list/`, { params });
    return res.data;
  },
};

export const assignments = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
